import React from 'react'
import styled from 'styled-components'
import { motion } from 'framer-motion'
import LazyImage from '../../../components/LazyImage'
import { Button, Icon } from 'rsuite'
import { Link } from 'react-router-dom'
import { useCongress } from '../../../congress/hooks'
import { LG_BREAKPOINT } from '../../../breakpoints'

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1,
  }
}

export default function Header ({ imageURL, name, position }) {
  const { generateLink } = useCongress()

  return (
   <Container variants={itemVariants}>
     <BackButtonContainer>
       <Button
         to={generateLink('/speakers')}
         componentClass={Link}
         appearance="subtle"
       >
         <Icon icon="angle-left" size="2x"/>
       </Button>
     </BackButtonContainer>
     <ImageContainer>
       <Image src={imageURL} width="6.4rem" height="6.4rem"/>
     </ImageContainer>
     <TextContainer>
       <Name>{name}</Name>
       <Position>{position}</Position>
     </TextContainer>
   </Container>
  )
}

const Container = styled(motion.div)`
  display: flex;
  align-items: center;
  margin-bottom: 6.7rem;
  position: relative;
`

const BackButtonContainer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: stretch;
  transform: translateX(calc(-100% - 0.4rem));
  
  a {
    padding: 0 2rem;
    display: flex;
    height: 100%;
    align-items: center;
  }
  
  @media screen and (max-width: ${LG_BREAKPOINT}em) {
    display: none;
  }
`

const ImageContainer = styled.div`
  padding: 0.8rem;
  border-radius: 40px;
  background: #FFF;
  display: inline-block;
  box-shadow: 0 4px 9px rgba(5, 26, 93, 0.19);
`

const Image = styled(LazyImage)`
  border-radius: 32px;
  overflow: hidden;
`

const TextContainer = styled.div`
  margin-left: 2.7rem;
`

const Name = styled.h3`
  font-weight: 300;
`

const Position = styled.p`
`
